import { render, staticRenderFns } from "./ChannelSalesCard.vue?vue&type=template&id=2a7cda12&scoped=true"
import script from "./ChannelSalesCard.vue?vue&type=script&lang=js"
export * from "./ChannelSalesCard.vue?vue&type=script&lang=js"
import style0 from "./ChannelSalesCard.vue?vue&type=style&index=0&id=2a7cda12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7cda12",
  null
  
)

export default component.exports